import { render, staticRenderFns } from "./TtiAudio.vue?vue&type=template&id=5fb9923e"
import script from "./TtiAudio.vue?vue&type=script&lang=ts"
export * from "./TtiAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports